export const plans = [
    {
        name:"basic_plan",
        crmProductId:"6697882000000793720",
        description:"basic_plan_desc",
        contractServices:[1,2],
        renew:"monthly",
        price:99,
        benefits:[
            'online_doctor',           // רופא אונליין 24/7
            'home_doctor',             // רופא עד הבית 24/7
            'ambulance_service',       // פינוי באמבולנס   
            'consult_specialist',      // התייעצות עם רופאים מומחים
            'diagnostic_tests',        // בדיקות אבחנתיות
            'preventive_tests',        // בדיקות לרפואה מונעת
            'screening_tests',         // בדיקות סקר (כולל סרטן)
            'physiotherapy',           // טיפולי פיזיותרפיה
            'hydrotherapy',            // טיפולי הידרותרפיה
            'pregnancy_tests',         // בדיקות הריון
        ]
    },
    // {
    //     name:"plus_plan",
    //     crmProductId:"6697882000000793704",
    //     description:"plus_plan_desc",
    //     renew:"monthly",
    //     price:169,
    //     benefits:[
    //         'consult_specialist',      // התייעצות עם רופאים מומחים
    //         'diagnostic_tests',        // בדיקות אבחנתיות
    //         'preventive_tests',        // בדיקות לרפואה מונעת
    //         'screening_tests',         // בדיקות סקר (כולל סרטן)
    //         'physiotherapy',           // טיפולי פיזיותרפיה
    //         'hydrotherapy',            // טיפולי הידרותרפיה
    //         'pregnancy_tests',         // בדיקות הריון
    //         'pain_clinics',            // טיפולים במרפאות כאב
    //         'adhd_testing',            // אבחון קשב וריכוז לילדים
    //         'capsule_endoscopy',       // בדיקת קפסולה אנדוסקופית
    //         'sleep_labs',              // בדיקות במעבדות שינה
    //         'food_intolerance_tests',  // בדיקות אי סבילות למזון
    //         'expanded_maternity',      // סל הריון מורחב
    //         'birth_preparation',       // קורס הכנה ללידה
    //         'doula_service',           // שירותי דולה
    //         'postpartum_hotel',        // שהייה במלונית לאחר לידה
    //         'lactation_consultant',    // יועצת הנקה מוסמכת
    //     ]
    // },
    {
        name:"premium_plan",
        crmProductId:"6697882000000765409",
        description:"premium_plan_plus_desc",
        contractServices:[1,2,3],
        renew:"monthly",
        price:229,
        benefits:[
            'online_doctor',           // רופא אונליין 24/7
            'home_doctor',             // רופא עד הבית 24/7
            'ambulance_service',       // פינוי באמבולנס
            'consult_specialist',      // התייעצות עם רופאים מומחים
            'diagnostic_tests',        // בדיקות אבחנתיות
            'preventive_tests',        // בדיקות לרפואה מונעת
            'screening_tests',         // בדיקות סקר (כולל סרטן)
            'physiotherapy',           // טיפולי פיזיותרפיה
            'hydrotherapy',            // טיפולי הידרותרפיה
            'pregnancy_tests',         // בדיקות הריון
            'pain_clinics',            // טיפולים במרפאות כאב
            'adhd_testing',            // אבחון קשב וריכוז לילדים
            'capsule_endoscopy',       // בדיקת קפסולה אנדוסקופית
            'sleep_labs',              // בדיקות במעבדות שינה
            'food_intolerance_tests',  // בדיקות אי סבילות למזון
            'expanded_maternity',      // סל הריון מורחב
            'birth_preparation',       // קורס הכנה ללידה
            'doula_service',           // שירותי דולה
            'postpartum_hotel',        // שהייה במלונית לאחר לידה
            'lactation_consultant',    // יועצת הנקה מוסמכת

        ]
    }
]